import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import MobileSubNavigator from '../../components/MobileSubNavigator';
import { useLocation, useNavigate } from 'react-router-dom';

const staticLinks = [
  // 게시판 관리는 마지막에 추가되도록 변경
];

const MobileCommunity = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [links, setLinks] = useState([]);
  
  console.log('MobileCommunity - 현재 links 상태:', links);

  useEffect(() => {
    // API 호출하여 테이블 이름 가져오기 - PC 버전 코드 그대로 복사
    const fetchBoardTables = async () => {
      try {
        const response = await fetch('/request/getBoardTables?category=Community',{credentials:'include'}); // 실제 API 엔드포인트로 변경
        const data = await response.json();

        // 가져온 테이블 이름을 링크로 변환
        const dynamicLinks = data.map(table => ({
          path: `/Community/Board/${table.boardId}`,
          label: table.boardTitle // ants_ 및 _board 제거하여 보기 좋게 만듦
        }));

        // 동적 링크 먼저, 그 다음 게시판 관리 추가
        const adminLink = { path: '/Community/BoardAdmin', label: '게시판 관리' };
        setLinks([...dynamicLinks, adminLink]);
      } catch (error) {
        console.error('Error fetching board tables:', error);
      }
    };

    fetchBoardTables();
  }, []);
  
  useEffect(()=>{
    if (links.length > 0 ) {
      if(location?.state?.fromNavigator===true){
        navigate(links[0].path);
      }
    }
  },[location,links])

  return (
    <MobileSubNavigator 
      links={links} 
      sectionTitle="커뮤니티"
      backPath="/"
    >
      <Outlet />
    </MobileSubNavigator>
  );
};

export default MobileCommunity;